var lastFocusedElement = null;

var getMiniCart = function() {
  return document.querySelector('.cart-container .cart_content');
};

var getMiniCartHeading = function() {
  return document.getElementById('mini-cart-title');
};

var getMiniCartCloseButton = function() {
  return document.querySelector('.cart-container .mini-cart-close');
};

var closeMiniCart = function() {
  $('.dropdown_link').toggleClass('active_link');

  $('.cart-container .cart_content').removeClass('active');
  $('.cart-container .drawer__overlay').removeClass('active');
  document.body.classList.remove('blocked-scroll');
  document.body.classList.remove('block-scroll');

  if (lastFocusedElement) {
    lastFocusedElement.focus();
    lastFocusedElement = null;
  }
};

var openMiniCart = function(triggerElement) {
  lastFocusedElement = triggerElement || document.activeElement;

  $('.mobile_nav div').removeClass('open');
  $('.dropdown_link').removeClass('active_link');

  $('.cart-container .cart_content').addClass('active');
  $('.cart-container .drawer__overlay').addClass('active');

  if (!document.body.classList.contains('blocked-scroll')) {
    setTimeout(function() {
      document.body.classList.add('blocked-scroll');
      document.body.classList.add('block-scroll');
    }, 500);
  }

  setTimeout(function() {
    var heading = getMiniCartHeading();
    var closeButton = getMiniCartCloseButton();
    var cart = getMiniCart();

    if (heading) {
      heading.focus();
    } else if (closeButton) {
      closeButton.focus();
    } else if (cart) {
      cart.setAttribute('tabindex', '-1');
      cart.focus();
    }
  }, 0);
};

var trapMiniCartFocus = function(e) {
  var cart = document.querySelector('.cart-container .cart_content.active');
  if (!cart) return;

  if (e.key === 'Escape') {
    closeMiniCart();
    return;
  }

  if (e.key !== 'Tab') return;

  var focusable = cart.querySelectorAll(
    'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );

  if (!focusable.length) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
};

document.addEventListener('keydown', trapMiniCartFocus);

window.addEventListener('resize', function(){
  if($('[index-logo-bar]').length > 0) {
    var $indexLogoSlider = $('[index-logo-bar] .logo-bar');
    var logo_option_val = $indexLogoSlider.data('flickity_val');
    
    if ($(window).width() > 798) {
      if($indexLogoSlider.hasClass('flickity-enabled')){
        // DESTROYED
        $indexLogoSlider.flickity('destroy');
      }
    } else {
      if(!$indexLogoSlider.hasClass('flickity-enabled')) {
        // INIT
        $indexLogoSlider.flickity(logo_option_val);
      }
    }
  }
});

$(document).ready(function () {
  // Search page
  // if(window.location.href.indexOf('/search') > -1 && window.location.href.indexOf('/sort') > -1) {
  //   // By default, choose best selling
  //   let url = new URL(location.href);
  //   let params = new URLSearchParams(url.search.slice(1));

  //   //Add a second foo parameter.
  //   params.append('sort', 'best-selling');
  // }

  window.dispatchEvent(new Event('resize'));
  
  if($('[index-banner]').length > 0) {
    var $indexBanSlider = $('[index-banner] .carousel');
    var ban_Slide_option_val = $indexBanSlider.data('flickity_val');

    $indexBanSlider.on('ready.flickity', function(e) {
      $(this).closest('section').removeClass('before-loading');
    });

    $indexBanSlider.flickity(ban_Slide_option_val);

    // Flickity banner instance
    var instanceBanSlier = $indexBanSlider.data('flickity');
    var $banSliderTxtItems = $('[index-banner] .slider-items-text--wrapper .item-text');

    $indexBanSlider.on( 'select.flickity', function() {
      $banSliderTxtItems.filter('.is-selected').removeClass('is-selected');
      $banSliderTxtItems.eq(instanceBanSlier.selectedIndex).addClass('is-selected');
    });
  }

  if($('[index-testimonial]').length > 0 && $(window).width() > 798) {
    var $indexTesimonialSlider = $('[index-testimonial] .carousel');
    var testimonial_Slide_option_val = $indexTesimonialSlider.data('flickity_val');
    $indexTesimonialSlider.flickity(testimonial_Slide_option_val);

    // var $indexTesimonialSlider1 = $('.featured-link--half .nav.one-whole');
    // var testimonial_Slide_option_val1 = $indexTesimonialSlider1.data('flickity_val');
    // $indexTesimonialSlider1.flickity(testimonial_Slide_option_val1);

    // Flickity testimonial instance
    var instanceTestimonialSlier = $indexTesimonialSlider.data('flickity');
    var $testimonialSliderTxtItems = $('[index-testimonial] .slider-items-text--wrapper .item-text');
    var $testimonialSliderDots = $('[index-testimonial] .slider-items-text--wrapper .slide-dots-wrapper .dot');

    $indexTesimonialSlider.on( 'select.flickity', function() {
      $testimonialSliderTxtItems.filter('.is-selected').removeClass('is-selected');
      $testimonialSliderTxtItems.eq(instanceTestimonialSlier.selectedIndex).addClass('is-selected');

      $testimonialSliderDots.filter('.is-selected').removeClass('is-selected');
      $testimonialSliderDots.eq(instanceTestimonialSlier.selectedIndex).addClass('is-selected');
    });

    $testimonialSliderDots.on('click', function(){
      var index = $(this).index();
      $indexTesimonialSlider.find(`.flickity-page-dots .dot:eq(${index})`).trigger('click');
    });
  }

  if($('[index-testimonial]').length > 0 && $(window).width() < 798) {
    $('.index-testimonial .image-with-text__text-column .slider-items-text--wrapper .slide-dots-wrapper').remove();
    $('.index-testimonial .image-with-text__text-column .slider-items-text--wrapper').flickity({
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      autoPlay: false
    });
  }

  if($('.product-featured-collection .featured--inner-wrapper').length > 0 && $(window).width() < 560) {
    $('.product-featured-collection .featured--inner-wrapper').flickity({
      wrapAround: true
    });
  }

  if($('[index-grid-column]').length > 0) {
    var $featuredEventSlider = $('[index-grid-column] .carousel');
    var evt_option_val = $featuredEventSlider.data('flickity_val');
    $featuredEventSlider.flickity(evt_option_val);
  }

  if($('[index-featured-items]').length > 0) {
    var $featuredItemSlider = $('[index-featured-items] .carousel');
    var item_option_val = $featuredItemSlider.data('flickity_val');
    $featuredItemSlider.flickity(item_option_val);

    var instanceFeaturedItemSlider = $featuredItemSlider.data('flickity');
    var $csArrows =  $('[index-featured-items] .cs-arrows');

    var allItemsNum = $csArrows.data('all-cnt');
    var dotsNum = $csArrows.data('dots-cnt');

    $featuredItemSlider.on( 'select.flickity', function() {
      _index = instanceFeaturedItemSlider.selectedIndex + 1;

      if(_index == 1) {
        $csArrows.find('.current').text(_index);
        $csArrows.find('.cs-arrow').removeClass('available');
        $csArrows.find('.next-btn').addClass('available');
      } else if(_index == dotsNum) {
        $csArrows.find('.current').text(allItemsNum);
        $csArrows.find('.cs-arrow').removeClass('available');
        $csArrows.find('.prev-btn').addClass('available');
      } else {
        $csArrows.find('.current').text(_index);
        $csArrows.find('.cs-arrow').addClass('available');
      }
    });

    // previous
    $csArrows.on('click', '.prev-btn', function() {
      $featuredItemSlider.flickity('previous');
    });
    // next
    $csArrows.on('click', '.next-btn', function() {
      $featuredItemSlider.flickity('next');
    });
  }

  if($('body .shopify-features').length > 0) {

    if ($(window).width() <= 798) {
      $shopify_features = $('body .shopify-features .carousel');
      $shopify_features.flickity({
        wrapAround: true
        // freeScroll: true
      });
    } else {
      $shopify_features = $('body .shopify-features .carousel');
      $shopify_features.flickity($shopify_features.data('flickity_val'));
    }
  }

  // Stays page START
  if($('body.page-stay .carousel-main').length > 0) {
    var $p_img_carousel = $('body.page-stay .carousel-main');

    if($(window).width() <= 798) {
      $p_img_carousel.flickity({
        prevNextButtons: false,
        adaptiveHeight: true,
        pageDots: true
      });

      $('body.page-stay .bottom-description').on('click', 'h5', function(){
        var $parentDOM = $(this).closest('div');
        $parentDOM.toggleClass('open');

        if($parentDOM.hasClass('open')) {
          $parentDOM.find('ul').animate({
            height: "100%"
          }, 300);
        } else {
          $parentDOM.find('ul').animate({
            height: 0
          }, 300);
        }
      });
    } else {
      $p_img_carousel.flickity({
        prevNextButtons: false,
        adaptiveHeight: true
      });
    }
  }
  // Stays page END

  if($('[product-blogs]').length > 0 && $(window).width() <= 798) {
    $product_blogs = $('[product-blogs] .carousel');
    $product_blogs.flickity($product_blogs.data('flickity_val'));
  }

  if ($(window).width() <= 798) {
    $('.mega-menu-1 .dropdown_content .dropdown_column__menu .dropdown_title.sublinks a').on('click', function (e) {
      e.preventDefault();
      $('.mega-menu-1 .dropdown_content .dropdown_column__menu').removeClass('active');
      $(this).parents('.dropdown_column__menu').addClass('active');
    })
  }


  if ($(window).width() <= 798) {
    $('.medium-down-carousel').each(function () {
      var option_val = $(this).data('flickity_val');
      $(this).flickity(option_val);
    })
  }

  // article page slider
  if($('body.article .gallery-slider').length > 0) {
    $('body.article .gallery-slider').flickity({
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: false, 
      groupCells:1,
      pageDots: false,
      autoPlay: true,
      autoPlay: 5000
    });
  }

// $('.create-acces-slider').flickity({
//       prevNextButtons: false,
//       adaptiveHeight: false, 
//       groupCells:4,
//       pageDots: false,
//       autoPlay: false
//     });
if($('.create-acces-slider').length == 1)
{  
$('.create-acces-slider').slick({
  dots: false,
  infinite: false,
  arrows:false,
  speed: 300,
  slidesToShow: 4,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 799,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}
  $('.article_content blockquote img').each(function () {
    $(this).after(`<span class="alt">${$(this).attr('alt')}</span>`)
  })

  if(window.PXUTheme.theme_settings.cart_action != 'redirect_cart') {
    $(".mini_cart").on("click", function(e) {
      e.preventDefault();

      var $cart_container = $('.cart-container .cart_content');

      if($cart_container.hasClass('active')) {
        closeMiniCart();
      } else {
        openMiniCart();
      }
    });

    $(".cart_content .close").on('click', function (e) {
      e.preventDefault();
      closeMiniCart();
    })
  }

  $('.category-selection').on('change', function (e) {
    e.preventDefault();

    $('.faq-categories .category-button').removeClass('active');
    $(this).addClass('active');
    var id = $(this).val();
    $('.faq__column-1').addClass('hide');
    $(id).removeClass('hide');
  });
  


  $(document).on('click', '.recommended-products .control-pannel .ss-icon', function(){
    var qty = parseInt($(this).closest('.product-quantity-box').find('input').val());

    if ($(this).hasClass('product-minus')) {
      if(qty > 1) {
        qty = qty - 1;
      } else return !0;
    } else {
      qty = qty + 1;
    }

    $(this).closest('.product-quantity-box').find('input').val(qty);
  });

  $('.description a.more').on('click', function (e) {
    e.preventDefault();
    
    $('.less-content').hide();
    $('.more-content').fadeIn();
  })

  $('.description a.less').on('click', function (e) {
    e.preventDefault();
    
    $('.more-content').hide();
    $('.less-content').fadeIn();
  })

  function YouTubeGetID(url){
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }

  $('#accordion').on('click', '.video-link', function(e){
    e.preventDefault();
    e.stopPropagation();
    var video_id = YouTubeGetID($(this).attr('href').toString());

    $.fancybox.open('<div class="media-popup-wrapper"><div class="inner-wrapper"><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/'+ video_id +'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>');
  });

  $(document).on('change', '.blog-category.v-mob select', function(e){
    window.location.href = $(this).val();
  });

  function create3DPopup (modelData) {
    var { sub_heading, virtual_models, captions, service_links } = modelData;

    var _mediaPopup = '<div class="third-tour">';
    _mediaPopup += ['<div class="heading text-center">','<h2>3D Virtual Bell Tent Tour</h2>','<p>'+ sub_heading +'</p>','</div>'].join('');
    _mediaPopup += '<div class="items-wrapper">';

    var _modelItems = '';

    for (let i = 0; i < virtual_models.length; i++) {
      if(virtual_models[i] != '' && virtual_models[i].indexOf('no-image') == -1) {
        _modelItems += '<div class="media-item">';

        if(service_links[i] != '') _modelItems += '<a href="'+ service_links[i] +'" target="_blank">';
        
        _modelItems += '<img src="'+ virtual_models[i] +'">';

        if(service_links[i] != '') _modelItems += '</a>';
        
        if(captions[i] != '')_modelItems += '<div class="item-title">'+ captions[i] +'</div>';

        _modelItems += '</div>';
      }
    }

    _mediaPopup += _modelItems;
    _mediaPopup += '</div>';
    _mediaPopup += '</div>';

    return _modelItems != '' ? _mediaPopup : '';
  }
  // 3D Tour
  $(document).on('click', '.product-badge', function(e){
    var model_type = $(this).data('model-type');
    

    switch(model_type) {
      case 'fernweh':
        var popupHTML = create3DPopup(window.themeSettings.fernweh);
        if(popupHTML != '') $.fancybox.open(popupHTML);
        break;
      case 'stella':
        var popupHTML = create3DPopup(window.themeSettings.stella);
        if(popupHTML != '') $.fancybox.open(popupHTML);
        break;
      default:
    }
  });
  
});

$(document).on('click', '.ajax_add_cart_button',function (e) {
  e.preventDefault();
  var id = $(this).attr('data-id');
  var quantity = parseInt($(this).closest('.control-pannel').find('input').val());

  var postData = {
    "id": id,
    "quantity": quantity,
    properties: {
      'upsell-product': 'true'
    }
  };

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: postData,
    success: function(itemData){
      if($('body').data('template').indexOf('cart') > -1) {
        // cart page
        location.href = '/cart';
      } else {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success: function(cart){
            // refreshCart(cart);
            document.dispatchEvent(new CustomEvent('refreshCart', { detail: cart }));
          }
        });
      }
    },
  });
})

// $(function() {
//   var Accordion = function(el, multiple) {
//       this.el = el || {};
//       this.multiple = multiple || false;

//       var links = this.el.find('.article-title');
//       links.on('click', {
//           el: this.el,
//           multiple: this.multiple
//       }, this.dropdown)
//   }

//   Accordion.prototype.dropdown = function(e) {
//       var $el = e.data.el;
//       $this = $(this),
//           $next = $this.next();

//       $next.slideToggle();
//       $this.parent().toggleClass('open');

//       if (!e.data.multiple) {
//           $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
//       };
//   }
//   var accordion = new Accordion($('.accordion-container'), false);
// });

$(function() {
  var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      var links = this.el.find('.article-title');
      links.on('click', {
          el: this.el,
          multiple: this.multiple
      }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
      var $this = $(this),
          $parent = $this.parent('article'),
          $next = $this.next('.accordion-content');

      // Keep all accordions open, only toggle the clicked one
      $parent.toggleClass('open');
      $next.slideToggle();
  }

  var accordion = new Accordion($('.accordion-container'), true);
});



$(document).on('change', 'select.route', function(e) {
  e.preventDefault();
  var link = $(this).val();
  location = link;
})

$(document).on('click', '.faq-categories .category-button', function (e) {
  e.preventDefault();
  $('.faq-categories .category-button').removeClass('active');
  $(this).addClass('active');
  var id = $(this).attr('href')
  $('.faq__column-1').addClass('hide');
  $(id).removeClass('hide')
})

$(document).on('click', '.side_modal_btn', function (e) {
  e.preventDefault();
  $('.side_bar_pannel').toggleClass('hide')
})

$(document).on('click', '.side_bar_pannel .side_bar_header .close', function (e) {
  e.preventDefault();
  $('.side_bar_pannel').toggleClass('hide')
})

$(document).on('click', '.cart-container .drawer__overlay', function (e) {
  closeMiniCart();
});

$(document).ready(function(){
  $(".mobile-only .price-ui").html($(".desktop-only .price-ui").html()).removeClass("price-ui--loading");
});


// Product add-on
$(document).on('click', '.btn-add-on', function(e) {
  var vId = $(this).data('add_on_id');
  var $addOnBtn = $('body .btn-add-on');

  productAddOn(vId)
  .then((cartItems) => {
    $addOnBtn.find('.checkmark').addClass('checkmark-active');

    window.setTimeout(function(){
      $addOnBtn.removeAttr('disabled').removeClass('disabled');
      $addOnBtn.find('.checkmark').removeClass('checkmark-active');
      $addOnBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
    }, 1000);

    $.ajax({
      url: '/cart.js',
      dataType: "json",
      cache: false,
      success: function(cart) {
        setTimeout(function() {
          // refreshCart(cart);
          document.dispatchEvent(new CustomEvent('refreshCart', { detail: cart }));

          if($('body').hasClass('fancybox-active')) {
            $.fancybox.close();
          }

          if($('#header').is(':visible')) {
            $('#header .cart-container').addClass('active_link');
          } else if ($('.sticky_nav--stick').length) {
            $('.sticky_nav .cart-container').addClass('active_link');
          } else {
            $('.top-bar .cart-container').addClass('active_link');
          }

          openMiniCart();
        }, 500);
      }
    });
  })
  .catch(err => {
    console.log(err)
    var response = eval('(' + err.responseText + ')');
    response = response.description;
    // $('.warning').remove();

    // var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
    // $addToCartForm.after(warning);
    // $addToCartBtn.removeAttr('disabled').removeClass('disabled');
    // $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
  })
});

function productAddOn (id) {
  var $addOnBtn = $('body .btn-add-on');
  var data = { 'id': id, 'quantity': 1 };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      beforeSend: function() {
        $addOnBtn.attr('disabled', 'disabled').addClass('disabled');
        $addOnBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: resolve,
      error: reject
    });
  })
}


if (window.PXUTheme.theme_settings.cart_action == 'ajax'){
  $(document).on('click', '.ajax-submit', function(e) {
    e.preventDefault();
    var $addToCartForm = $(this).closest('form');
    var $addToCartBtn = $addToCartForm.find('.add_to_cart');

    //Refresh page on quick shop add to cart if on cart page
    if($('body').hasClass('cart')) {
      $addToCartForm.submit();
    }

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function(itemData) {
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        window.setTimeout(function(){
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
        }, 1000);

        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            setTimeout(function() {
              // refreshCart(cart);
              document.dispatchEvent(new CustomEvent('refreshCart', { detail: cart }));
              
              if($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }

              if($('#header').is(':visible')) {
                $('#header .cart-container').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart-container').addClass('active_link');
              } else {
                $('.top-bar .cart-container').addClass('active_link');
              }

              openMiniCart();

            }, 500)
          }
        });
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();

        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartForm.after(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
      }
    });

    return false;
  });
}


document.addEventListener("refreshCart", function(e){
  var cart = e.detail;

  $(".cart_count").empty();
  $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || '0';
  var cart_items_html = "";
  var cart_discounts_html = "";
  var cart_action_html = "";
  var cart_savings_html = "";
  var $cart_form = $('[data-cart-form]');
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;
  var item_count = 0;
  var recomments = [];
  var upsell_status = false;
  $cart_form.data('total-discount', cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cart_form.addClass('hidden');
  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $cart_form.removeClass('hidden');

    var total_saving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, function(index, item) {
      var itemDiscounts = item.discounts;
      var discountMessage = "";

      for (i=0; i < itemDiscounts.length; i++) {
        var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
        var title = itemDiscounts[i].title;
        discountMessage = '<p class="notification-discount meta">' + title + '</p>';
      }
      var line_id = index + 1;

      cart_items_html += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + line_id + '" data-variant-id="' + item.id + '">';
      if (item.image) {
        cart_items_html += ['<div class="cart_image">','<a href="' + item.url +'">','<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />','</a></div>'].join('');
      }

      var tag_html = '';
      if(item.properties) {
        $.each(item.properties, function(title, value) {
          if (value && title != 'upsell-product') {
            tag_html += '<div class="line-item">' + title +': ' + value + ' </div>';
          }
        });
      }
      
      var variant_info_html = [];
      if(item.product_has_only_default_variant != true) {
        variant_info_html = item.options_with_values.map(r => `<span class="variant-info">${r.name}: ${r.value}</span>`).join('');
      }

      cart_items_html += '<div class="mini-cart__item--content cart-item">';
      cart_items_html += '<div class="mini-cart__item__title">';
      cart_items_html += ['<div class="item_title">','<a href="' + item.url + '">','<span class="item-title">' + item.product_title + '</span>',variant_info_html,tag_html,'</a>','</div>'].join('');

      cart_items_html += '<div class="price">';

      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        url: "/products/" + item.handle + ".js",
        success: function(data) {
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (data.variants) {
            var itemVariants = data.variants;
            if (itemVariants.length > 1) {
              for (v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id == item.id) {
                  var data = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (data.compare_at_price) {
            if(data.compare_at_price > data.price) {
              productHasSale = true;
              productCompareAtPrice = data.compare_at_price;
              productFinalPrice = data.price;
            }
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        }
      });

      if(productHasSale == true) {
        //puts the slash through the old item price
        var itemPrice = Shopify.formatMoney(productFinalPrice, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format')) + '</span>';
        cart_items_html += '<span class="money sale">' + itemPrice + '</div>';

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        total_saving = saving + total_saving;
      } else {
        if (item.price > item.final_price) {
          //puts the slash through the old item price
          var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
          cart_items_html += '<span class="money sale">' + itemPrice + '</div>';
        } else {
          var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
          cart_items_html += '<span class="money">' + itemPrice + '</span></div>';
        }
      }

      if (item.price > item.final_price) {
        cart_items_html += discountMessage;
      }

      cart_items_html += '</div>';

      cart_items_html += ['<div class="product-quantity-box">','<div class="mini-cart-qty">','<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>','<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart" />','<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>','</div>','<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + '" data-remove-item="mini-cart" aria-label="Remove: "><span class="remove-icon"></span></a>','</div>'].join('');

      cart_items_html += '</div>';

      $.ajax({
        url: '/products/'+item.handle+'.js',
        dataType: 'json',
        cache: false,
        type: 'get',
        success(data) {
          recommend_products_str = "";
          item_count ++;
          for (let i = 0; i < data.tags.length; i++) {
            const tag = data.tags[i];
            if (tag.indexOf('upsell:') > -1) {
              var recommended_str = tag.replace("upsell:", "");
              if (recommend_products_str.length == 0) {
                recommend_products_str = recommended_str;
              }else if (recommended_str.length > 0) {
                recommend_products_str = recommend_products_str + ',' + recommended_str;
              } 
            }
          }
          recomments[line_id-1] = recommend_products_str;
        }
      });
    });
    // $.each END

    var cartDiscounts = cart.cart_level_discount_applications;
    var cartDiscountMessage = "";

    for (i=0; i < cartDiscounts.length; i++) {
      var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
      var title = cartDiscounts[i].title;

      cart_discounts_html += '<span class="cart_discounts--title">' + title + '</span>';
      cart_discounts_html += '<span class="cart_discounts--price">';
      cart_discounts_html += '-<span class="money">' + amount + '</span></span>';
    }

    cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>' + window.PXUTheme.translation.cart_subtotal_text + '</span>';
    total_saving = total_saving + cart.total_discount;
    if(window.PXUTheme.theme_settings.display_savings && total_saving > 0) {
      cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_saving, $('body').data('money-format')) + '</span></span>' +
          '<span>' + window.PXUTheme.translation.cart_savings_text + '</span>';
    } else {
      cart_savings_html = "";
    }
  }

  $('.js-cart_items').html(cart_items_html);
  $('.js-cart_discounts').html(cart_discounts_html);
  $('.js-cart_subtotal').html(cart_action_html);
  $('.js-cart_savings').html(cart_savings_html);

  // Converting the currencies
  if (Currency.show_multiple_currencies) {
    currencyConverter.convertCurrencies();
  }
  
  var refreshIntervalId = setInterval(() => {
    if (item_count == cart.items.length) {
      var names = [];
      recomments.reverse();
      var recommend_products_str = '';
      for (let index = 0; index < recomments.length; index++) {
        const recommend_str = recomments[index];
        recommend_products_str += recommend_str + ",";
      }
      for (let i = 0; i < cart.items.length; i++) {
        const line_item = cart.items[i];
        var indicator = line_item.handle;
        recommend_products_str =  recommend_products_str.replaceAll(indicator, "");
      }

      recommend_products_str = recommend_products_str.trim();
      names = recommend_products_str.split(",");
      
      var recommend_products = [];
      $.each(names, function(i, el){
        if($.inArray(el, recommend_products) === -1 && el !== "") recommend_products.push(el);
      });
      AppendRecommend(0, recommend_products, upsell_status);
      clearInterval(refreshIntervalId);
    }
  }, 100);
});

function AppendRecommend(index, recommend_products, status) {
  console.log(recommend_products)
  console.log(index)
  if (!status) {
    var recommend_status = true;
    const pro_handle = recommend_products[index];
    var i = index;
    if (pro_handle != undefined) {
      $.ajax({
        url: '/products/'+pro_handle+'.js',
        dataType: 'json',
        cache: false,
        type: 'get',
        success(product) {
          var related_product_id = '';
          var related_product_img = ''
          for (let i = 0; i < product.variants.length; i++) {
            const variant = product.variants[i];
            if(variant.available) {
              related_product_id = variant.id;
              if(variant.featured_image != null) related_product_img = variant.featured_image.src;
              else related_product_img = product.images[0];
              break;
            }
          }
          if (recommend_status) { 
            if (product.available) {
              relateProductHtml = `<ul class="recommended-products"><h6>You may also need</h6><li class="mini-cart__item relate_product">
                                      <script type="application/json" class="bold-product-json">${ JSON.stringify(product) }</script>
                                      <div class="mini_cart_image mini-cart__item-image">
                                        <a class="image_link" href="${product.url}">
                                          <img src="${related_product_img}" alt="${product.title}" class="lazyload">
                                        </a>
                                      </div>
                                      <div class="mini-cart__item--content">
                                          <div class="mini-cart__item__title">
                                            <div class="item_title">
                                              <a href="${product.url}">${product.title}</a>
                                            </div>
                                            <div class="price">
                                              <span class="money" data-product-id="${product.id}" itemprop="price">${Shopify.formatMoney(product.price, $('body').data('money-format'))}</span>
                                            </div>
                                          </div>
                                          
                                          <div class="control-pannel">
                                            <div class="product-quantity-box">
                                              <div class="mini-cart-qty">
                                                <span class="ss-icon product-minus" data-func="minus">
                                                <span class="icon-minus"></span>
                                                </span>
                            
                                                <input type="number" min="0" size="2" class="quantity" value="1" data-cart-quantity-input="mini-cart" aria-label="Quantity for />
                            
                                                <span class="ss-icon product-plus" data-func="plus">
                                                <span class="icon-plus"></span>
                                                </span>
                                              </div>
                                              <a class="btn btn-small ajax_add_cart_button" data-id="${related_product_id}" data-quantity="1"> + ADD</a>
                                            </div>
                                          </div>
                                      </div>
                                  </li></ul>`;
              $('.cart_content .js-cart_items').append(relateProductHtml);
              recommend_status = false;
            } else {
              i++;
              AppendRecommend(i, recommend_products)
            }
          }
        },
        error: function (error) {
          i++;
          AppendRecommend(i, recommend_products)
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var carouselCount = 0;

  function getCarouselLabel(carousel) {
    return (
      carousel.getAttribute('aria-label') ||
      carousel.getAttribute('data-carousel-label') ||
      'carousel'
    );
  }

  function ensureSkipTarget(carousel, idBase) {
    var nextEl = carousel.nextElementSibling;

    if (nextEl && nextEl.classList.contains('flickity-skip-target')) {
      if (!nextEl.id) {
        nextEl.id = idBase + '-target';
      }
      if (!nextEl.hasAttribute('tabindex')) {
        nextEl.setAttribute('tabindex', '-1');
      }
      return nextEl.id;
    }

    var target = document.createElement('div');
    target.className = 'flickity-skip-target';
    target.id = idBase + '-target';
    target.setAttribute('tabindex', '-1');
    target.setAttribute('aria-hidden', 'true');

    carousel.insertAdjacentElement('afterend', target);
    return target.id;
  }

  function ensureSkipLink(carousel) {
    if (carousel.dataset.skipLinkAdded === 'true') {
      return;
    }

    carouselCount += 1;
    var idBase = carousel.id || 'flickity-carousel-' + carouselCount;
    if (!carousel.id) {
      carousel.id = idBase;
    }

    var targetId = ensureSkipTarget(carousel, idBase);
    var label = getCarouselLabel(carousel);

    var skipLink = document.createElement('a');
    skipLink.className = 'flickity-skip-link';
    skipLink.href = '#' + targetId;
    skipLink.textContent = 'Skip ' + label;

    carousel.insertAdjacentElement('beforebegin', skipLink);
    carousel.dataset.skipLinkAdded = 'true';
  }

  function removeAriaSelected(carousel) {
    var slides = carousel.querySelectorAll('.flickity-slider > *');
    slides.forEach(function (slide) {
      if (slide.hasAttribute('aria-selected')) {
        slide.removeAttribute('aria-selected');
      }
    });
  }

  function processCarousels(root) {
    var scope = root || document;

    var carousels = scope.querySelectorAll('.js-flickity, .flickity-enabled');
    carousels.forEach(function (carousel) {
      ensureSkipLink(carousel);
      removeAriaSelected(carousel);
    });

    if (
      scope.nodeType === 1 &&
      (scope.matches('.js-flickity') || scope.matches('.flickity-enabled'))
    ) {
      ensureSkipLink(scope);
      removeAriaSelected(scope);
    }
  }

  processCarousels(document);

  setTimeout(function () {
    processCarousels(document);
  }, 500);

  setTimeout(function () {
    processCarousels(document);
  }, 1500);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            processCarousels(node);
          }
        });
      }

      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-selected' &&
        mutation.target.nodeType === 1
      ) {
        mutation.target.removeAttribute('aria-selected');
      }

      if (
        mutation.type === 'attributes' &&
        mutation.target.nodeType === 1 &&
        (
          mutation.attributeName === 'class' ||
          mutation.attributeName === 'style'
        )
      ) {
        processCarousels(mutation.target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-selected', 'class', 'style']
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.flickity-skip-link');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    var target = document.querySelector(href);
    if (!target) return;

    setTimeout(function () {
      target.focus();
    }, 0);
  });
});